/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when an `authFixture` could not be found by a given `username` and `password`
 * @export
 * @class AuthCouldNotFindFixtureByUsernameAndPasswordError
 * @extends {Error}
 */
export class AuthCouldNotFindFixtureByUsernameAndPasswordError extends Error {
  /**
   * Creates an instance of AuthCouldNotFindFixtureByUsernameAndPasswordError
   * @param {string} message The Error `message`
   * @memberof AuthCouldNotFindFixtureByUsernameAndPasswordError
   */
  constructor(message) {
    super(message);
    this.name = `AuthCouldNotFindFixtureByUsernameAndPasswordError`;
  }
}

/**
 * Called when an `authFixture` could not be found by a given `username` and `password`
 * @param {string} username The `username` for the `userFixture`
 * @param {string} password The `password` for the `userFixture`
 * @returns {never} never
 */
const throwAuthCouldNotFindFixtureByUsernameAndPasswordError = (username, password) => {
  throw new AuthCouldNotFindFixtureByUsernameAndPasswordError(
    stripIndent(`
    Could not find a user fixture with username and password: "${username}", "${password}".
    Are you sure that users exists in "usersFixture"?
    `),
  );
};

export default throwAuthCouldNotFindFixtureByUsernameAndPasswordError;
